import { get } from '@classic/Foundation/Services/ApiService'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ApiServiceError } from '@mobi/account/Utils'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { RacingEvents } from '@core/Areas/VenueMode/Components/Racing/Data/types'

export function useVenueModeRacingEvents(autoRefreshEnabled = true): UseQueryResult<RacingEvents> {
  return useQuery({
    queryFn: () => getVenueModeRacingEvents(),
    enabled: autoRefreshEnabled,
    refetchInterval: 30_000,
    staleTime: Infinity,
    retry: (failureCount, error) =>
      failureCount < 3 && (error as ApiServiceError)?.response?.status !== 404,
    retryDelay: 250,
    refetchOnReconnect: true,
    queryKey: [queryKeys.venueModeRacingRacingEvents],
    refetchOnWindowFocus: true,
  })
}

async function getVenueModeRacingEvents(): Promise<RacingEvents> {
  return await get<RacingEvents>({
    url: `/api/fobracing/getVenueModeRacingEvents`,
  })
}
